var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.typeControlPermission)?_c('Topbar',{ref:"con1",on:{"inid":_vm.inid}}):_c('span',{domProps:{"textContent":_vm._s('您沒有管理權限')}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }